import { ClipboardModule } from '@angular/cdk/clipboard';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FileUploadModule } from '@vectorsolv/vectors-ui/file-input';
import { AddressModule } from '@vsolv/core/address/web';
import { PackagesEmailWebModule } from '@vsolv/packages/email/web';
import { UtilsModule } from '@vsolv/ui-kit/utils';
import { AlertModule } from '@vsolv/vectors-ui/alert';
import { AppPageModule } from '@vsolv/vectors-ui/app-page';
import { BadgeModule } from '@vsolv/vectors-ui/badge';
import { ButtonModule } from '@vsolv/vectors-ui/button';
import { CardModule } from '@vsolv/vectors-ui/card';
import { DatePickerModule } from '@vsolv/vectors-ui/date-picker';
import { DialogModule } from '@vsolv/vectors-ui/dialog';
import { DividerModule } from '@vsolv/vectors-ui/divider';
import { FormsModule } from '@vsolv/vectors-ui/forms';
import { IconsModule } from '@vsolv/vectors-ui/icons';
import { ImagePreviewModule } from '@vsolv/vectors-ui/image-preview';
import { InputModule } from '@vsolv/vectors-ui/input';
import { MenuModule } from '@vsolv/vectors-ui/menu';
import { RichTextEditorModule } from '@vsolv/vectors-ui/rich-text-editor';
import { SelectModule } from '@vsolv/vectors-ui/select';
import { TabsModule } from '@vsolv/vectors-ui/tabs';
import { ThemingModule } from '@vsolv/vectors-ui/theming';
import { TooltipModule } from '@vsolv/vectors-ui/tooltip';
import { UserAvatarModule } from '@vsolv/vectors-ui/user-avatar';
import { TableModule } from '@vsolv/vectors/table';
import { SftpWebModule } from '@wsphere/sftp/web';
import {
  ApiKeysTableComponent,
  AppCardComponent,
  ClaimApprovalSettingsComponent,
  ClaimResolutionSettingsComponent,
  CustomerPortalDetailsComponent,
  GatewayInstancesTableComponent,
  GatewayRoutingRulesComponent,
  NotFoundComponent,
} from './components';
import {
  AppCardDialog,
  BfsDialog,
  DecodedKeyPreviewDialog,
  EditApiKeyDialog,
  EditCheckoutConfirmationTextDialog,
  EditClaimsMessageDialog,
  EditPromoTextDialog,
  EmailDocumentDialog,
  GenerateApiKeyDialog,
  LemurDialog,
  GatewayInstanceDialog,
  ManageWebhooksDialog,
  RollApiKeyDialog,
  SftpDialog,
  StripeTaxDialog,
  TaxJarDialog,
} from './dialogs';
import { ChatbotDialog } from './dialogs/chatbot-dialog';
import { CreateEmailTemplateDialog } from './dialogs/create-email-template/create-email-template.dialog';
import { DeleteApiKeyDialog } from './dialogs/delete-api-key-dialog';
import { EditEmailTemplateDialog } from './dialogs/edit-email-template/edit-email-template.dialog';
import { EmailTemplatePreviewDialog } from './dialogs/email-template-preview/email-template-preview.dialog';
import {
  AppsPage,
  DeveloperPage,
  EmailPage,
  EmailTemplatesPage,
  EmailsPage,
  FeatureFlagsPage,
  OrganizationPage,
} from './pages';

@NgModule({
  imports: [
    RichTextEditorModule,
    ReactiveFormsModule,
    CommonModule,
    AppPageModule,
    AddressModule,
    RouterModule,
    CardModule,
    IconsModule,
    ThemingModule,
    BadgeModule,
    DialogModule,
    DividerModule,
    ReactiveFormsModule,
    FormsModule,
    IconsModule,
    InputModule,
    SelectModule,
    TableModule,
    ButtonModule,
    IconsModule,
    CardModule,
    InputModule,
    ImagePreviewModule,
    ThemingModule,
    ButtonModule,
    ThemingModule,
    TabsModule,
    UtilsModule,
    AlertModule,
    DividerModule,
    TooltipModule,
    UserAvatarModule,
    DatePickerModule,
    MenuModule,
    OverlayModule,
    ClipboardModule,
    PackagesEmailWebModule,
    SftpWebModule,
    FileUploadModule,
  ],
  declarations: [
    NotFoundComponent,
    EditPromoTextDialog,
    EditClaimsMessageDialog,
    EditCheckoutConfirmationTextDialog,
    ApiKeysTableComponent,
    GatewayInstancesTableComponent,
    GatewayRoutingRulesComponent,
    DeleteApiKeyDialog,
    EditApiKeyDialog,
    GenerateApiKeyDialog,
    GatewayInstanceDialog,
    RollApiKeyDialog,
    DeveloperPage,
    FeatureFlagsPage,
    OrganizationPage,
    AppsPage,
    EmailTemplatesPage,
    CustomerPortalDetailsComponent,
    DecodedKeyPreviewDialog,
    ManageWebhooksDialog,
    AppCardComponent,
    EmailDocumentDialog,
    LemurDialog,
    BfsDialog,
    ChatbotDialog,
    AppCardDialog,
    SftpDialog,
    TaxJarDialog,
    StripeTaxDialog,
    ClaimResolutionSettingsComponent,
    ClaimApprovalSettingsComponent,
    EmailsPage,
    EmailPage,
    EmailTemplatePreviewDialog,
    CreateEmailTemplateDialog,
    EditEmailTemplateDialog,
  ],
  providers: [],
  exports: [DeveloperPage, OrganizationPage],
})
export class TenantsWebModule {}
